<template>
  <div id="sideMenu" class="mt-5">
    <div class="text-left" shadow>
      <!-- <p style="font-size: 24px" class=""><b>หมวดหมู่</b></p>
      <div class="side-menu-border px-2 py-2">
        <button
          @click="categorytClick('')"
          class="btn btn-outline-white btn-block side-menu text-left pl-0 btnHover"
        >
          คอร์สเรียนทั้งหมด
        </button>
      </div>
      <div class="side-menu-border px-2 py-2 mt-2 mb-5">
        <button
          v-for="item in category"
          :key="item.id"
          @click="categorytClick(item.id)"
          href="#"
          class="btn btn-outline-white btn-block side-menu text-left pl-0 btnHover"
        >
          {{ item.name }}
        </button>
      </div> -->
      <p style="font-size: 24px" class=""><b>Ebook</b></p>
      <div class="side-menu-border mt-2 mb-5"  style="padding: 10px;">
        <button
        @click="$router.push('/e-book?id=1')" 
          class="btn btn-outline-white btn-block side-menu text-left  btnHover"
          style="padding-left: 15px;"
        >
          รายการโปรด
        </button>
        <button
        @click="$router.push('/e-book?id=2')" 
          class="btn btn-outline-white btn-block side-menu text-left btnHover"
          style="padding-right: 15px;"
        >
          รายการทั้งหมด
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "sideMenu",
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      category: (state) => state.Category.category,
    }),
  },
  created() {
    this.getCategory();
  },
  methods: {
    async getCategory() {
      await this.$store.dispatch("Category/getCategory");
    },
    async categorytClick(id) {
      this.isLoading = true;

      if (id == "allCourses") {
        let path = `/all-courses`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      } else if (id == "allTeachers") {
        let path = `/all-teachers`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      } else if (id == "favoriteMenuEbook") {
        let path = `/favorite-menu-book/${id}`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      }
      else if (id == "Ebook") {
        let path = `/e-book?id=1`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      }  else {
        // await this.$store.dispatch("Courses/getAllCourse", {favorite-menu-book
        //   category: id,
        //   keyword: null,
        // });
        let path = `/category/${id}`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      }

      this.isLoading = false;
    },
  },
};
</script>
<style>
@media screen and (max-width: 992px) {
  #sideMenu {
    display: none;
  }
}

/*button.side-menu:hover {*/
/*  background-color: #2c3143; !* Green *!*/
/*  color: white;*/
/*}*/
</style>
